// extracted by mini-css-extract-plugin
export default {"modal":"AddressValidatorModal-module__modal___EWvpu"};